import { render, staticRenderFns } from "./ai-customer-knowledge.vue?vue&type=template&id=70856d6a&"
import script from "./ai-customer-knowledge.vue?vue&type=script&lang=js&"
export * from "./ai-customer-knowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports